import type { CommunicationTemplateType } from "@bbj-types/communication/enum";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { useMemo } from "react";
import { type Control, Controller, type UseFormSetValue } from "react-hook-form";
import type { IModalTemplate } from "../emailModalContent";
import type { INotifyBySmsModalForm } from "../types";

interface ISmsTemplateListFormProps {
  control: Control<INotifyBySmsModalForm, void>;
  setValue: UseFormSetValue<INotifyBySmsModalForm>;
  templates: (IModalTemplate & { type: CommunicationTemplateType.SMS })[];
}

export const MenuTemplateSms = ({ control, templates, setValue }: ISmsTemplateListFormProps) => {
  const parsedTemplates = useMemo(() => {
    const result = new Map<string, Omit<IModalTemplate, "_id">>();

    return templates.reduce((acc, curr) => {
      const { _id, ...rest } = curr;
      acc.set(_id, rest);
      return acc;
    }, result);
  }, [templates]);

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
      }}
    >
      <Controller
        control={control}
        name="type"
        render={({ field: { onChange }, fieldState: { error } }) => (
          <Autocomplete
            options={templates}
            getOptionLabel={(template) => template.name}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            onChange={(_, value) => {
              onChange(value?.name);
              const content = parsedTemplates.get(value?._id ?? "")?.content ?? "";
              setValue("content", {
                text: content,
                html: content,
              });
            }}
            size="small"
            sx={{ minWidth: "424px" }}
            renderInput={(props) => (
              <TextField {...props} error={!!error} helperText={error?.message} label={<Box>Modèle</Box>} />
            )}
          />
        )}
      />
    </Stack>
  );
};
